import { NewExpeditionForm } from '@app/pages/expedition/create/types.ts';
import { generateUUID } from '@utils/utils.tsx';
import { applyExpeditionDefaults } from '@app/pages/expedition/create/defaults.ts';

/**
 * The bare shape of the form: a route with nothing on it, and no answer to any shipment parameter.
 *
 * Deliberately free of defaults, so that a prefill mapping on top of it can tell "the source said
 * nothing" from "the source said this". Callers that want the defaults ask for them explicitly —
 * see {@link newExpeditionInitialDataWithDefaults}.
 */
export const newExpeditionInitialData = (): NewExpeditionForm => {
  const ret = {
    locations: [
      {
        location: null,
        loadingReference: null,
        localityMode: 'FROM_LOCATIONS',
        id: generateUUID(),
        orders: [],
        unloadingOrderIds: null,
        timeslots: { dayWithInterval: [] },
      },
      {
        location: null,
        loadingReference: null,
        localityMode: 'FROM_LOCATIONS',
        id: generateUUID(),
        orders: null,
        unloadingOrderIds: [],
        timeslots: { dayWithInterval: [] },
      },
    ],
    distribution: null,
  } as NewExpeditionForm;

  return ret;
};

/** A blank shipment as the user first sees it: the defaults filled in and visible, not applied behind their back. */
export const newExpeditionInitialDataWithDefaults = (): NewExpeditionForm => applyExpeditionDefaults(newExpeditionInitialData());
